import { TenantEntity } from '../TenantEntity'

export class Container extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get isDirty() {
    return this._data.isDirty
  }
  set isDirty(isDirty) {
    this._data.dirty = isDirty
  }
  // =====================非db 字段，关联的装箱信息============
  get containerUsage() {
    return this._data.containerUsage
  }
  set containerUsage(containerUsage) {
    this._data.containerUsage = containerUsage || []
  }
  get seaEqs() {
    return this._data.seaEqs
  }
  set seaEqs(seaEqs) {
    this._data.seaEqs = seaEqs
  }
  // =====================非db 字段，关联的装箱信息============

  get containerId() {
    return this._data.containerId
  }
  set containerId(containerId) {
    this._data.containerId = containerId
  }
  get containerNo() {
    return this._data.containerNo
  }
  set containerNo(containerNo) {
    if (this._data.containerNo === containerNo) return
    this._data.isDirty = true
    this._data.containerNo = containerNo
  }
  get sealNo() {
    return this._data.sealNo
  }
  set sealNo(sealNo) {
    if (this._data.sealNo === sealNo) return
    this._data.isDirty = true
    this._data.sealNo = sealNo
  }
  get reSealed() {
    return this._data.reSealed
  }
  set reSealed(reSealed) {
    if (this._data.reSealed === reSealed) return
    this._data.isDirty = true
    this._data.reSealed = reSealed || false
  }
  get eqType() {
    return this._data.eqType
  }
  set eqType(eqType) {
    if (this._data.eqType === eqType) return
    this._data.isDirty = true
    this._data.eqType = eqType
  }
  get eqSize() {
    return this._data.eqSize
  }
  set eqSize(eqSize) {
    if (this._data.eqSize === eqSize) return
    this._data.isDirty = true
    this._data.eqSize = eqSize
  }
  get remark() {
    return this._data.remark
  }
  set remark(remark) {
    if (this._data.remark === remark) return
    this._data.isDirty = true
    this._data.remark = remark
  }
  get containerWeight() {
    return this._data.containerWeight
  }
  set containerWeight(containerWeight) {
    if (this._data.containerWeight === containerWeight) return
    this._data.isDirty = true
    this._data.containerWeight = containerWeight || 0.0
  }
  get cargoName() {
    return this._data.cargoName
  }
  set cargoName(cargoName) {
    if (this._data.cargoName === cargoName) return
    this._data.isDirty = true
    this._data.cargoName = cargoName
  }
  get mark() {
    return this._data.mark
  }
  set mark(mark) {
    if (this._data.mark === mark) return
    this._data.isDirty = true
    this._data.mark = mark
  }
  get vGMWeight() {
    return this._data.vGMWeight
  }
  set vGMWeight(vGMWeight) {
    if (this._data.vGMWeight === vGMWeight) return
    this._data.isDirty = true
    this._data.vGMWeight = vGMWeight || 0.0
  }
  get vGMWeightingMeothd() {
    return this._data.vGMWeightingMeothd
  }
  set vGMWeightingMeothd(vGMWeightingMeothd) {
    if (this._data.vGMWeightingMeothd === vGMWeightingMeothd) return
    this._data.isDirty = true
    this._data.vGMWeightingMeothd = vGMWeightingMeothd
  }
  get vGMWeightingTime() {
    return this._data.vGMWeightingTime
  }
  set vGMWeightingTime(vGMWeightingTime) {
    if (this._data.vGMWeightingTime === vGMWeightingTime) return
    this._data.isDirty = true
    this._data.vGMWeightingTime = vGMWeightingTime
  }
  get vGMWeightingPlace() {
    return this._data.vGMWeightingPlace
  }
  set vGMWeightingPlace(vGMWeightingPlace) {
    if (this._data.vGMWeightingPlace === vGMWeightingPlace) return
    this._data.isDirty = true
    this._data.vGMWeightingPlace = vGMWeightingPlace
  }
  get quantity() {
    return this._data.quantity
  }
  set quantity(quantity) {
    if (this._data.quantity === quantity) return
    this._data.isDirty = true
    this._data.quantity = quantity || 0
  }
  get weight() {
    return this._data.weight
  }
  set weight(weight) {
    if (this._data.weight === weight) return
    this._data.isDirty = true
    this._data.weight = weight || 0.0
  }
  get cubage() {
    return this._data.cubage
  }
  set cubage(cubage) {
    if (this._data.cubage === cubage) return
    this._data.isDirty = true
    this._data.cubage = cubage || 0.0
  }
  get approachDate() {
    return this._data.approachDate
  }
  set approachDate(approachDate) {
    if (this._data.approachDate === approachDate) return
    this._data.isDirty = true
    this._data.approachDate = approachDate
  }
  get emptyCabinetDate() {
    return this._data.emptyCabinetDate
  }
  set emptyCabinetDate(emptyCabinetDate) {
    if (this._data.emptyCabinetDate === emptyCabinetDate) return
    this._data.isDirty = true
    this._data.emptyCabinetDate = emptyCabinetDate
  }
  get actualLiftingDate() {
    return this._data.actualLiftingDate
  }
  set actualLiftingDate(actualLiftingDate) {
    if (this._data.actualLiftingDate === actualLiftingDate) return
    this._data.isDirty = true
    this._data.actualLiftingDate = actualLiftingDate
  }
  get deliveryDate() {
    return this._data.deliveryDate
  }
  set deliveryDate(deliveryDate) {
    if (this._data.deliveryDate === deliveryDate) return
    this._data.isDirty = true
    this._data.deliveryDate = deliveryDate
  }
  get deliveryDoneDate() {
    return this._data.deliveryDoneDate
  }
  set deliveryDoneDate(deliveryDoneDate) {
    if (this._data.deliveryDoneDate === deliveryDoneDate) return
    this._data.isDirty = true
    this._data.deliveryDoneDate = deliveryDoneDate
  }
  get cleaningDate() {
    return this._data.cleaningDate
  }
  set cleaningDate(cleaningDate) {
    if (this._data.cleaningDate === cleaningDate) return
    this._data.isDirty = true
    this._data.cleaningDate = cleaningDate
  }
  get returnDate() {
    return this._data.returnDate
  }
  set returnDate(returnDate) {
    if (this._data.returnDate === returnDate) return
    this._data.isDirty = true
    this._data.returnDate = returnDate
  }
  get playDate() {
    return this._data.playDate
  }
  set playDate(playDate) {
    if (this._data.playDate === playDate) return
    this._data.isDirty = true
    this._data.playDate = playDate
  }
  get dischargingPort() {
    return this._data.dischargingPort
  }
  set dischargingPort(dischargingPort) {
    if (this._data.dischargingPort === dischargingPort) return
    this._data.isDirty = true
    this._data.dischargingPort = dischargingPort
  }
  get destinationPort() {
    return this._data.destinationPort
  }
  set destinationPort(destinationPort) {
    if (this._data.destinationPort === destinationPort) return
    this._data.isDirty = true
    this._data.destinationPort = destinationPort
  }
  get transportMessageDate() {
    return this._data.transportMessageDate
  }
  set transportMessageDate(transportMessageDate) {
    if (this._data.transportMessageDate === transportMessageDate) return
    this._data.isDirty = true
    this._data.transportMessageDate = transportMessageDate
  }
  get wharfReleaseDate() {
    return this._data.wharfReleaseDate
  }
  set wharfReleaseDate(wharfReleaseDate) {
    if (this._data.wharfReleaseDate === wharfReleaseDate) return
    this._data.isDirty = true
    this._data.wharfReleaseDate = wharfReleaseDate
  }
  get customReleaseDate() {
    return this._data.customReleaseDate
  }
  set customReleaseDate(customReleaseDate) {
    if (this._data.customReleaseDate === customReleaseDate) return
    this._data.isDirty = true
    this._data.customReleaseDate = customReleaseDate
  }
  get lfd() {
    return this._data.lfd
  }
  set lfd(lfd) {
    if (this._data.lfd === lfd) return
    this._data.isDirty = true
    this._data.lfd = lfd
  }
  get containerAscription() {
    return this._data.containerAscription
  }
  set containerAscription(containerAscription) {
    if (this._data.containerAscription === containerAscription) return
    this._data.isDirty = true
    this._data.containerAscription = containerAscription
  }
  get boxAscription() {
    return this._data.boxAscription
  }
  set boxAscription(boxAscription) {
    if (this._data.boxAscription === boxAscription) return
    this._data.isDirty = true
    this._data.boxAscription = boxAscription || 0
  }
  get plateNumber() {
    return this._data.plateNumber
  }
  set plateNumber(plateNumber) {
    if (this._data.plateNumber === plateNumber) return
    this._data.isDirty = true
    this._data.plateNumber = plateNumber
  }
  get plateApproachDate() {
    return this._data.plateApproachDate
  }
  set plateApproachDate(plateApproachDate) {
    if (this._data.plateApproachDate === plateApproachDate) return
    this._data.isDirty = true
    this._data.plateApproachDate = plateApproachDate
  }
  get platePlayDate() {
    return this._data.platePlayDate
  }
  set platePlayDate(platePlayDate) {
    if (this._data.platePlayDate === platePlayDate) return
    this._data.isDirty = true
    this._data.platePlayDate = platePlayDate
  }
  get loadingPort() {
    return this._data.loadingPort
  }
  set loadingPort(loadingPort) {
    if (this._data.loadingPort === loadingPort) return
    this._data.isDirty = true
    this._data.loadingPort = loadingPort
  }
  get inSpected() {
    return this._data.inSpected
  }
  set inSpected(inSpected) {
    if (this._data.inSpected === inSpected) return
    this._data.isDirty = true
    this._data.inSpected = inSpected || false
  }
  get boxOwner() {
    return this._data.boxOwner
  }
  set boxOwner(boxOwner) {
    if (this._data.boxOwner === boxOwner) return
    this._data.isDirty = true
    this._data.boxOwner = boxOwner || 0
  }
  get returnBoxTime() {
    return this._data.returnBoxTime
  }
  set returnBoxTime(returnBoxTime) {
    if (this._data.returnBoxTime === returnBoxTime) return
    this._data.isDirty = true
    this._data.returnBoxTime = returnBoxTime
  }
  get jobUuid() {
    return this._data.jobUuid
  }
  set jobUuid(jobUuid) {
    if (this._data.jobUuid === jobUuid) return
    this._data.isDirty = true
    this._data.jobUuid = jobUuid
  }
  get loadingDate() {
    return this._data.loadingDate
  }
  set loadingDate(loadingDate) {
    if (this._data.loadingDate === loadingDate) return
    this._data.isDirty = true
    this._data.loadingDate = loadingDate
  }
  get state() {
    return this._data.state
  }
  set state(state) {
    if (this._data.state === state) return
    this._data.isDirty = true
    this._data.state = state || 0
  }
  // 送仓时间
  get destinationDeliveryTime() {
    return this._data.destinationDeliveryTime
  }
  set destinationDeliveryTime(destinationDeliveryTime) {
    if (this._data.destinationDeliveryTime === destinationDeliveryTime) return
    this._data.isDirty = true
    this._data.destinationDeliveryTime = destinationDeliveryTime
  }
  // 还空时间
  get destinationReturnTime() {
    return this._data.destinationReturnTime
  }
  set destinationReturnTime(destinationReturnTime) {
    if (this._data.destinationReturnTime === destinationReturnTime) return
    this._data.isDirty = true
    this._data.destinationReturnTime = destinationReturnTime
  }
  // 卸船时间
  get portDischargeTime() {
    return this._data.portDischargeTime
  }
  set portDischargeTime(portDischargeTime) {
    if (this._data.portDischargeTime === portDischargeTime) return
    this._data.isDirty = true
    this._data.portDischargeTime = portDischargeTime
  }
  // 提重时间
  get actualPickUpTime() {
    return this._data.actualPickUpTime
  }
  set actualPickUpTime(actualPickUpTime) {
    if (this._data.actualPickUpTime === actualPickUpTime) return
    this._data.isDirty = true
    this._data.actualPickUpTime = actualPickUpTime
  }

  // 长度
  get sizeLength() {
    return this._data.sizeLength
  }
  set sizeLength(sizeLength) {
    if (this._data.sizeLength === sizeLength) return
    this._data.isDirty = true
    this._data.sizeLength = sizeLength
  }
  // 宽度
  get sizeWidth() {
    return this._data.sizeWidth
  }
  set sizeWidth(sizeWidth) {
    if (this._data.sizeWidth === sizeWidth) return
    this._data.isDirty = true
    this._data.sizeWidth = sizeWidth
  }
  // 高度
  get sizeHeight() {
    return this._data.sizeHeight
  }
  set sizeHeight(sizeHeight) {
    if (this._data.sizeHeight === sizeHeight) return
    this._data.isDirty = true
    this._data.sizeHeight = sizeHeight
  }
  // 控箱人
  get boxController() {
    return this._data.boxController
  }
  set boxController(boxController) {
    this._data.boxController = boxController
  }
  // 车皮号
  get carNumber() {
    return this._data.carNumber
  }
  set carNumber(carNumber) {
    this._data.carNumber = carNumber
  }

  // 空柜通知时间
  get emptyContainerNotificationTime() {
    return this._data.emptyContainerNotificationTime
  }
  set emptyContainerNotificationTime(emptyContainerNotificationTime) {
    this._data.emptyContainerNotificationTime = emptyContainerNotificationTime
  }
  // 信号旗拼箱任务ID
  get xhqTaskId() {
    return this._data.xhqTaskId
  }
  set xhqTaskId(xhqTaskId) {
    this._data.xhqTaskId = xhqTaskId
  }
  // 箱序号
  get containerSeqNo() {
    return this._data.containerSeqNo
  }
  set containerSeqNo(containerSeqNo) {
    this._data.containerSeqNo = containerSeqNo
  }
  // 温度单位 CEL/FAH
  get reefTempUnit() {
    return this._data.reefTempUnit
  }
  set reefTempUnit(reefTempUnit) {
    this._data.reefTempUnit = reefTempUnit
  }
  // 通风量单位 CBM/H CFM/H
  get ventilationUnit() {
    return this._data.ventilationUnit
  }
  set ventilationUnit(ventilationUnit) {
    this._data.ventilationUnit = ventilationUnit
  }
}
